export default __webpack_public_path__ + "static/media/01.080d69e5.svg";